import React from "react";

const Successicon = () => {
  return (
    <svg
      width="91"
      height="91"
      viewBox="0 0 91 91"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_2906_1923)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M45.6264 90.7099C70.6742 90.7099 90.9794 70.4047 90.9794 45.3569C90.9794 20.3092 70.6742 0.00390625 45.6264 0.00390625C20.5787 0.00390625 0.273438 20.3092 0.273438 45.3569C0.273438 70.4047 20.5787 90.7099 45.6264 90.7099ZM37.1103 71.6328L75.1562 29.6858L66.8395 21.9783L36.5338 55.5735L22.605 42.6299L14.8625 50.9139L37.1103 71.6328Z"
          fill="url(#paint0_linear_2906_1923)"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_2906_1923"
          x1="91.156"
          y1="0.179469"
          x2="16.77"
          y2="102.687"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#74C85D" />
          <stop offset="1" stop-color="#58A942" />
        </linearGradient>
        <clipPath id="clip0_2906_1923">
          <rect width="91" height="91" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default Successicon;
